import React from 'react';
import { DataGrid } from '@material-ui/data-grid';
import './PopupTemplates.scss';

/**
 * Table with Top Chart Template - Header at top, table below with small chart on top right
 * Used for popups that need a table-focused view with supplementary chart
 */
const TableTopChartTemplate = ({
  header,
  tableConfig,
  topChart,
  pagination,
  onPaginationChange
}) => {
  const {
    rows = [],
    columns = [],
    totalElements = 0,
    gridProps = {}
  } = tableConfig || {};

  const defaultGridProps = {
    disableSelectionOnClick: true,
    pagination: true,
    paginationMode: "server",
    rowsPerPageOptions: [5, 10, 20, 50, 100],
    disableColumnFilter: true,
    disableColumnSelector: true,
    disableColumnMenu: true,
    localeText: { noRowsLabel: "No Data Available" },
    sx: {
      maxHeight: 500,
      minWidth: 800,
      overflowY: "auto",
      "& .MuiDataGrid-virtualScroller": {
        overflowY: "auto",
      },
    },
    ...gridProps
  };

  return (
    <div className="popup-content split-layout">
      {header}
      <div className="second-container">
        <div className="left-side-panel">
          <DataGrid
            rows={rows}
            columns={columns}
            rowCount={totalElements}
            page={pagination.page}
            pageSize={pagination.pageSize}
            onPageChange={(newPage) => onPaginationChange(prev => ({ ...prev, page: newPage }))}
            onPageSizeChange={(newPageSize) => onPaginationChange(prev => ({ ...prev, pageSize: newPageSize }))}
            {...defaultGridProps}
          />
        </div>
      </div>
    </div>
  );
};

export default TableTopChartTemplate;